// @ts-nocheck
import React from 'react';
// material
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TaxNumberField from 'commons/components/TaxNumberField';
import ButtonWithLoader from 'commons/containers/ButtonWithLoader';
import { withTranslation } from 'react-i18next';

function ClientForm(props) {
  return (
    <Dialog
      fullWidth
      onClose={props.toggleForm}
      aria-labelledby="simple-dialog-title"
      open={props.isOpen}>
      <DialogTitle>{`${props.edit ? props.t('clients.editTitle') : props.t('clients.createTitle')}`}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.name}
              onChange={props.changeControls}
              fullWidth
              id="name"
              label={props.t('Name')}
              error={props.invalidControls.name}
              helperText={props.invalidControls.name && props.t('clients.nameError')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TaxNumberField
              value={props.controls.taxNumber}
              onChange={props.onChange}
              label={props.t('identifier.taxNumber')}
              fullWidth
              error={props.invalidControls.taxNumber}
              helperText={props.invalidControls.taxNumber && props.t('identifier.validate_message')}
              inputProps={{ maxLength: 50 }}
              country={props.country}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.email}
              onChange={props.changeControls}
              fullWidth
              id="email"
              type="email"
              label={props.t('Email')}
              error={props.invalidControls.email}
              helperText={props.invalidControls.email && props.t('clients.emailError')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.code}
              onChange={props.changeControls}
              fullWidth
              id="code"
              label={props.t('Code')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.region}
              onChange={props.changeControls}
              fullWidth
              id="region"
              label={props.t('Region')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.province}
              onChange={props.changeControls}
              fullWidth
              id="province"
              label={props.t('Province')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.sector}
              onChange={props.changeControls}
              fullWidth
              id="sector"
              label={props.t('Sector')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <TextField
              value={props.controls.address}
              onChange={props.changeControls}
              fullWidth
              id="address"
              label={props.t('Address')}
              inputProps={{ maxLength: 50 }}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.controls.isInternalClient}
                  onChange={props.changeControls}
                  fullWidth
                  id="isInternalClient"
                  disabled={props.controls.isDefaultClient}
                />
              }
              label={props.t('clients.internalClient')}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.controls.isDefaultClient}
                  onChange={props.changeControls}
                  fullWidth
                  id="isDefaultClient"
                  disabled={props.controls.isInternalClient}
                />
              }
              label={props.t('clients.defaultClient')}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.toggleForm} color="primary">
          {props.t('Cancel')}
        </Button>
        <ButtonWithLoader onClick={props.submit} autoFocus buttonId="create-edit-client">
          {props.edit ? props.t('Edit') : props.t('ADD')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default withTranslation()(ClientForm);
